<template>
	<router-link :to="{ name: 'party', params: { partyId: partyId } }" class="party" :class="size">
		<div class="logoWrapper">
			<img :src="`images/parties/${party.logo}`" />
		</div>
	</router-link>
</template>

<script>
import { gsap } from 'gsap'
import { mapGetters } from 'vuex'

export default {
	props: {
		item: Object,
		size: String
	},

	computed: {
		...mapGetters(['getPartyById']),

		partyId() {
			return this.item.partyId
		},

		party() {
			return this.getPartyById(this.partyId)
		},

		windowWidth() {
			return window.innerWidth
		}
	},

	mounted() {
		this.calculateCirclePosition()
	},

	methods: {
		calculateCirclePosition() {
			const rect = this.$el.getBoundingClientRect()
			const x = rect.x + rect.width / 2

			// accommodate for large screens and max width of tokens
			const factor = Math.max((this.windowWidth - 420) / 300, 1)
			const procentage = Math.abs(x / this.windowWidth - 0.5) * 100

			gsap.set(this.$el, { yPercent: procentage * factor })
		}
	}
}
</script>

<style scoped lang="scss">
.party {
	border-radius: 100px;
	background: white;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px auto 10px auto;

	&.large {
		width: 100px;
		height: 100px;
	}

	&.medium {
		width: 80px;
		height: 80px;
	}

	&.small {
		width: 60px;
		height: 60px;
	}
}

.logoWrapper {
    aspect-ratio: 1;
	border-radius: 100px;
	overflow: hidden;
	background: white;
	display: flex;
	align-items: center;
	justify-content: center;
}

img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}
</style>
